import * as React from "react";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Facebook, Instagram, Twitter, LinkedIn } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import {
  ShoppingPortalDto,
  ShoppingPortalSetting,
} from "../../../models/features/ShoppingPortal/ShoppingPortalDto";
import { useEffect, useState } from "react";
import { DmsLocations } from "../../../models/auth/Auth";
import { ErrorMessage, Form, Formik } from "formik";
import {
  PortalCustomerLogin,
  PortalLoginValidationSchema,
  portalLoginDefault,
} from "../../../models/features/Customer/PortalLogin";
import { useDispatch } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { PortalCustomerLoginApi } from "../../../redux/reducer/features/Auth/authSlice";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useSelector } from "react-redux";

interface PortalSigninFormProps {}
export const PortalSigninForm: React.FunctionComponent<
  PortalSigninFormProps
> = (props) => {
  const { portalSettings } = useSelector(
    (state: AppState) => state.shoppingPortalReducer
  );
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch<Dispatch<any>>();
  const onLoginComplete = () => {
    setIsLoading(false);
  };
  const onError = () => {
    setIsLoading(false);
  };
  const handleOnSubmit = (values: PortalCustomerLogin) => {
    setIsLoading(true);
    dispatch(
      PortalCustomerLoginApi(
        { ...values, dmsSetupId: portalSettings?.setting.dmsSetupId ?? "" },
        onLoginComplete,
        onError
      )
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
        <LockOutlinedIcon />
      </Avatar> */}
      <Typography component="h1" variant="h5">
        Sign in
      </Typography>
      <Formik
        initialValues={portalLoginDefault}
        validationSchema={PortalLoginValidationSchema}
        onSubmit={(values) => {
          handleOnSubmit(values);
        }}
      >
        {({ values, errors, handleChange, handleBlur }) => (
          <>
            <Form>
              <Grid container spacing={2} alignItems="center" mt={1}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email"
                    size="small"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    autoComplete="email"
                  />
                  <ErrorMessage
                    className="error-msg"
                    component={"div"}
                    name="email"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Password"
                    size="small"
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    type="password"
                  />
                  <ErrorMessage
                    className="error-msg"
                    component={"div"}
                    name="password"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox value="remember" color="primary" />}
                    label="Remember me"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mb: 2 }}
                    disabled={isLoading}
                    startIcon={
                      isLoading ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        ""
                      )
                    }
                  >
                    Sign In
                  </Button>
                </Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>
    </Box>
  );
};
